import React, { useState } from "react";
import styled from "styled-components";
import { rem } from "polished";
import mq from "../../../helpers/media-queries";
import Breadcrumbs from "./Breadcrumbs";
import LimitedOfferIntro from "./LimitedOfferIntro";
import Bottom from "../../Bottom/Bottom";
import { useHistory } from "react-router-dom";
import Checkbox from "./Checkbox";

const Container = styled.div`
    ${mq("sm", "min")} {
        width: ${rem(420)};
        flex-shrink: 0;
        height: 100%;
        display: flex;
        background: #fff;
        display: flex;
        flex-direction: column;
        box-shadow: -4px 10px 14px rgba(0, 0, 0, 0.04);
        position: relative;
        z-index: 10;
        border-left: 1px solid #eaeaea;
        position: relative;
    }
`;

const Content = styled.div`
    ${mq("sm", "max")} {
        padding: ${rem(17)};
    }

    ${mq("sm", "min")} {
        padding: ${rem(40)};
        padding-top: ${rem(50)};
        flex: 1;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
    }
`;

const Button = styled.button`
    background: #cc6f4c;
    width: 100%;
    padding: ${rem(14)};
    border: 0;
    appearance: none;
    color: white;
    font-size: 20px;
    border-radius: 5px;
    cursor: pointer;
    font-family: sans-serif;
    transition: 0.3s;

    &:hover {
        background: #231914;
    }

    &[disabled] {
        opacity: 0.2;
        cursor: not-allowed;
    }

    &:focus {
        outline: none;
    }
`;

const Title = styled.h3`
    font-family: sans-serif;
    font-size: ${rem(24)};
    line-height: 1.3;
    font-weight: 400;
    font-family: sans-serif;
    padding-top: ${rem(10)};

    em {
        color: #9e3f3a;
    }
`;

const SubTitle = styled.p`
    font-size: ${rem(17)};
    font-family: sans-serif;
`;

const Text = styled.div`
    font-family: sans-serif;
    font-size: ${rem(13)};
    line-height: 1.5;
    color: #5c5e62;
    padding-top: ${rem(10)};
    margin-bottom: ${rem(16)};

    & > * + * {
        margin-top: ${rem(10)};
    }
`;

const Custom = styled.div`
    padding-bottom: ${rem(74)};
    border-top: 1px solid #dbdbdb;
`;

const Sidebar = ({
    path,
    breadcrumbData,
    checkBoxesData,
    keyFeaturesData,
    limitedOfferIntroData,
    setModelId,
    setmodelNodes,
}) => {
    const [activeBox, setActiveBox] = useState(1);
    const history = useHistory();

    let nextUrl;
    let nextTitle;
    switch (activeBox) {
        case 1:
            nextUrl = "custom";
            nextTitle = "Custom Package";
            break;
        case 2:
            nextUrl = "model/1";
            nextTitle = "Premium Package";
            break;
        case 3:
            nextUrl = "model/2";
            nextTitle = "Off-Grid Package";
            break;
    }

    async function handleSubmit(event) {
        const allBoxes = [...checkBoxesData, keyFeaturesData];

        history.push(`${path}/${nextUrl}`);
    }

    return (
        <Container>
            <Content>
                <Breadcrumbs links={breadcrumbData} />
                <SubTitle>Packages</SubTitle>
                <Text>Please select one of the following options and click orange button at the bottom</Text>
                <Custom>
                    <Title>Custom design</Title>
                    <Checkbox
                        key={keyFeaturesData.index}
                        onChange={() => {
                            setActiveBox(keyFeaturesData.id);
                            setModelId(keyFeaturesData.modelId);
                            if (keyFeaturesData.modelNodes) {
                                setmodelNodes(keyFeaturesData.modelNodes);
                            }
                        }}
                        {...keyFeaturesData}
                        isChecked={activeBox === 1}
                    />
                </Custom>
            </Content>

            <Bottom
                isOverview={false}
                nextStep={handleSubmit}
                nextTitle={nextTitle}
                isDisabled={activeBox === 0 ? true : false}
            />
        </Container>
    );
};

export default Sidebar;
